// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"Dashboard_mainContent__3rWxL","mainContentInner":"Dashboard_mainContentInner__2JRMH"};